import cloneDeep from 'lodash/cloneDeep';

class ProductProfile {
  constructor({PoolType, Sanitizer, PrevAlgaecide, MaintOxidizer, pHAdjuster, MaintClarifer, Winterizer, ID, SanitizerType}) {
    this.PoolType = PoolType;
    this.Sanitizer = Sanitizer;
    this.PrevAlgaecide = PrevAlgaecide;
    this.MaintOxidizer = MaintOxidizer;
    this.pHAdjuster = pHAdjuster;
    this.MaintClarifer = MaintClarifer;
    this.Winterizer = Winterizer;
    this.ID = ID;
    this.SanitizerType = SanitizerType;
  }

  clone() {
    return cloneDeep(this);
  }

  static fromApiFormat(api) {
    var elements = [];

    api.forEach(function(element) {
      elements.push(
				new ProductProfile({
  PoolType: element.PoolType,
  Sanitizer: element.Sanitizer,
  PrevAlgaecide: element.PrevAlgaecide,
  MaintOxidizer: element.MaintOxidizer,
  pHAdjuster: element.pHAdjuster,
  MaintClarifer: element.MaintClarifer,
  Winterizer: element.Winterizer,
  ID: element.ID,
  SanitizerType: element.SanitizerType,
}));
    }, this);
    return elements;
  }
}

export default ProductProfile;
